module.exports = __webpack_public_path__ + "img/Avatar-23.144b736f.svg";